<template>
  <div class="body">
    <div class="header">
      <div><img src="../../assets/css/icon/fh.png" class="left" @click="goBack"/></div>
      <div><img src="../../assets/imgs/m_share.svg" @click="shareOpen" class="right"/></div>
    </div>
    <div class="avatar" @click="goApply">
      <img class="logo" :src="userInfo.userImg"/>
      <div class="detail">
        <div class="name">{{ userInfo.username }}</div>
        <div class="info">
          <div>
            <span class="title">{{$t("trading_days")}}</span><br/>
            <span class="content">{{ userInfo.days }}</span>
          </div>
          <div>
            <span class="title">{{$t("follower_count")}}</span><br/>
            <span class="content">{{ userInfo.followCount }}</span>
          </div>
          <div>
            <span class="title">{{$t("total_follower_count")}}</span><br/>
            <span class="content">{{ userInfo.allFollowCount }}</span>
          </div>
          <div class="delete" v-show="showOrder">
            <svg t="1745750561104" class="delete" viewBox="0 0 1024 1024" version="1.1"
                 xmlns="http://www.w3.org/2000/svg"
                 p-id="3208" width="200" height="200" @click="showDel">
              <path
                  d="M751 157.4c45.2 6.4 92.2-1.8 129.1 4.5 59.7 10.2 90 61 83.5 135.8h-72.3c-2 132.7-1.1 264.1-1.1 397.3 0 67.2 5.6 137.8-1.1 198.1-6.3 56.9-48.1 91.6-99 100.1-50.3 8.4-117 2.2-172.5 2.2-116.4 0-234.3 2.3-348.3 0-55.5-1.1-96.5-18.7-121.3-52.3-24.8-33.6-22.3-84.4-22.3-144.7V297.7h-69c-11.2-68.8 18.6-118.3 69-134.6 37.1-12 86.5-2.3 139.1-5.6-4.3-74.1-0.2-130.3 63.4-138 28.5-3.4 66.5 0 101.3 0H632c38.6 0 78.1-3.7 97.9 13.4 27.3 23.5 20.2 78 21.1 124.5zM333.7 92.8v66.8H682V89.5H334.8c-1.3 0.2-1.2 1.7-1.1 3.3z m-67.9 212.6v424c0 36.2-8.3 113.4 13.4 129.1 8.6 6.2 30.9 7.2 41.2 0 22.4-15.6 14.5-90.6 14.5-128V302.1H267c-1.4 0.1-1.3 1.7-1.2 3.3z m207 0V716c0 32.4-7.5 109.1 5.6 131.3 8.6 14.7 37.8 21.3 52.3 10 19.7-15.4 11.1-96.6 11.1-130.2V302h-67.9c-1.3 0.2-1.2 1.8-1.1 3.4z m209.2 0v429.5c0 44-8.6 111.5 20 123.5 12.5 5.3 34.6 1.2 40.1-3.3 18.7-15.4 10-97.8 10-130.2V302.1h-69c-1.3 0.1-1.2 1.7-1.1 3.3z"
                  fill="#EAECEF" p-id="3209">

              </path>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div class="desc">
      <div :class="'detail '+ (showDetail?'show_detail':'hide_detail') " v-html="userInfo.text"></div>
      <div class="more"><img class="more" src="../../assets/imgs/down.svg" @click="showDetail=!showDetail"/></div>
    </div>
    <div class="menu">
      <div class="menu1">
        <div :class="'menu-item '+(selectMenuIndex==index?'active':'')" v-for="(item,index) in menu" v-if="item.show" :key="index"
             @click="selectMenu(index)">{{ item.title }}
        </div>
        <div class="menu-item refresh" @click="refresh">
          <svg t="1745751567117" class="icon" viewBox="0 0 1162 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
               p-id="4279" width="200" height="200">
            <path
                d="M1015.265248 720.230902h-8.677481a34.709923 34.709923 0 0 1-26.032442-52.064884 433.874038 433.874038 0 0 0-216.937019-538.003807 425.196557 425.196557 0 0 0-485.938922 86.774808 43.387404 43.387404 0 0 1-60.742365-60.742365A520.648845 520.648845 0 0 1 807.00571 52.064885 511.971364 511.971364 0 0 1 1058.652652 694.19846a43.387404 43.387404 0 0 1-43.387404 26.032442zM581.39121 1023.942729a538.003807 538.003807 0 0 1-225.614499-52.064885 520.648845 520.648845 0 0 1-260.324423-624.778614 43.387404 43.387404 0 0 1 60.742366-26.032442 43.387404 43.387404 0 0 1 26.032442 52.064884 433.874038 433.874038 0 0 0 216.937019 520.648845 425.196557 425.196557 0 0 0 485.938922-86.774807 43.387404 43.387404 0 1 1 60.742365 60.742365 485.938922 485.938922 0 0 1-364.454192 156.194654z"
                fill="#848E9C" p-id="4280"></path>
            <path
                d="M199.582057 494.616403c-17.354962 0-26.032442 0-34.709923-17.354962l-34.709923-52.064884-60.742365 52.064884a43.387404 43.387404 0 0 1-60.742365-8.67748 43.387404 43.387404 0 0 1 8.677481-60.742366l95.452288-78.097326c8.677481-8.677481 26.032442-17.354962 34.709923-8.677481s26.032442 8.677481 26.032442 17.354961L234.29198 433.874038c17.354962 17.354962 8.677481 43.387404-17.354961 60.742365zM1015.265248 746.263345h-8.677481l-26.032442-26.032443-52.064885-95.452288c-17.354962-17.354962-8.677481-43.387404 17.354962-60.742365a60.742365 60.742365 0 0 1 60.742365 17.354961l26.032442 60.742366 60.742366-52.064885a52.064885 52.064885 0 0 1 60.742365 8.677481c8.677481 17.354962 8.677481 52.064885-8.677481 60.742365l-104.129769 78.097327z"
                fill="#848E9C" p-id="4281"></path>
          </svg>
        </div>
      </div>
      <div class="menu2">
        <div :class="'menu-item2 '+(subSelect==index?'active':'')" v-for="(item,index) in subMenu" :key="index"
             @click="selectSubMenu(index)">{{ item }}
        </div>
      </div>
    </div>
    <div class="content">
      <overview1 ref="s0s0" v-show="selectMenuIndex==0 && subSelect==1" :contract-address="this.$route.query.contract"
                 :token="this.$route.query.token"/>
      <overview2 ref="s0s1" v-if="selectMenuIndex==0 && subSelect==0" :contract-address="this.$route.query.contract"
                 :token="this.$route.query.token"/>
      <activate0 ref="s1s0" v-show="selectMenuIndex==1 && subSelect==0" @pan-total="updatePan"
                 :contract-address="this.$route.query.contract" :token="this.$route.query.token"></activate0>
      <activate2 ref="s1s1" v-if="selectMenuIndex==1 && subSelect==1" :contract-address="this.$route.query.contract"
                 :token="this.$route.query.token"></activate2>
      <activate3 ref="s2s0" v-if="selectMenuIndex==2 && subSelect==0" :contract-address="this.$route.query.contract"
                 :token="this.$route.query.token"></activate3>

      <activity4_m ref="s3s0" v-if="selectMenuIndex==3 && subSelect==0" :contract-address="this.$route.query.contract"
                   :token="this.$route.query.token"></activity4_m>
      <activate1 ref="s3s1" v-if="selectMenuIndex==3 && subSelect==1" :contract-address="this.$route.query.contract"
                 :token="this.$route.query.token"></activate1>
      <activate8 ref="s3s2" v-if="selectMenuIndex==3 && subSelect==2" :contract-address="this.$route.query.contract"
                 :token="this.$route.query.token"></activate8>

      <activate6 ref="s4s0" v-if="selectMenuIndex==4 && subSelect==0" :contract-address="this.$route.query.contract"
                 :token="this.$route.query.token"></activate6>
      <activate7 ref="s4s1" v-if="selectMenuIndex==4 && subSelect==1" :contract-address="this.$route.query.contract"
                 :token="this.$route.query.token"></activate7>
    </div>
    <div class="quick_order" v-if="!showOrder && selectMenuIndex!=2" @click="goTrading">{{$t("copy_trading")}}</div>
    <el-dialog :modal="false" style="margin-top: 24vh" class="delete_dialog" :show-close="false"
               :visible.sync="showDeleteDialog" width="300px">
      <div class="text_box">
        {{ $t('confirm_delete') }}
      </div>
      <span slot="footer" class="dialog_footer_box">
        <el-button style="background: #C6FE61;color: #181A20" type="primary"
                   @click="ok1()">{{ $t("confirm") }}</el-button>
        <el-button class="cancel_box" @click="showDeleteDialog = false">{{ $t("cancel") }}</el-button>
      </span>
    </el-dialog>
    <share ref="share" :contract="this.$route.query.contract" :token="this.$route.query.token" ></share>
  </div>
</template>
<script>
import Overview1 from "../../components/overview1.vue";
import Overview2 from "../../components/overview2.vue";
import Activate0 from "../../components/activate0.vue";
import activate2 from "../../components/activate2.vue";
import Activate3 from "../../components/activate3.vue";
import Activate4 from "../../components/activate4.vue";
import Activity4_m from "../../components/activity4_m.vue";
import Activate1 from "../../components/activate1.vue";
import Activate6 from "../../components/activate6.vue";
import Activate7 from "../../components/activate7.vue";
import {
  createAndCall,
  createLeadingContractAndCall,
  createLeadingContractAndSend, getContractWithCache,
  getGasReward, getSelectTokenInfo, getValue
} from "../../utils/contract";
import {Contract, Method, Underling} from "../../config/const";
import {getAccount, getChainId, requestAccount} from "../../utils/wallet";
import {getDotAddress} from "../../utils/strings";
import {getLastPrice} from "../../service/priceService";
import {ethers} from "ethers";
import config from "../../config/config";
import Share from "../../components/share.vue";
import Activate8 from "../../components/activate8.vue";

export default {
  components: {
    Activate8,
    Share,
    Activate7,
    Activate6, Activate1, Activity4_m, Activate4, Activate3, activate2, Activate0, Overview2, Overview1
  },
  data() {
    return {
      menu: [
        {
          "title": this.$t("overview"),
          "subTitle": [],
          "show":true,
        },
        {
          "title": this.$t("position"),
          "subTitle": [this.$t("current_position"), this.$t("trade_history")],
          "show":true,
        },
        {
          "title": this.$t("copy_trading"),
          "subTitle": [],
          "show":true,
        },
        {
          "title": this.$t("place_order"),
          "subTitle": [this.$t("place_order"), this.$t("current_orders"),this.$t("order_history")],
          "show":false,
        },
        {
          "title": this.$t("users"),
          "subTitle": [this.$t("follower_users"), this.$t("pending_withdrawal_users")],
          "show":true,
        },
      ],
      subMenu: [],
      selectMenuIndex: 0,
      subSelect: 0,
      contractAddress: "",
      token: "",
      userInfo: {
        username: "",
        days: 0,
        followCount: 0,
        allFollowCount: 0,
        text:"--",
        userImg: require('../../assets/css/icon/head.svg'),
      },
      //todo
      showOrder: false,
      showDeleteDialog: false,
      showDetail:false
    }
  },
  mounted() {
    this.hideTopAndBottom()
    this.getInfo()
    window.addEventListener("resize",this.resize)
  },

  unmounted() {
    window.removeEventListener("resize")
  },

  created() {
    let isFollow=this.$route.query.follow;
    if(isFollow===true){
      this.selectMenuIndex=2;
    }
    this.created()
  },
  methods: {
    resize(){
      if(document.body.clientWidth>750){
        window.location.href="/#/listPage?contract="+this.$route.query.contract+"&token="+this.$route.query.token
      }
    },
    goTrading(){
      this.selectMenuIndex=2
      this.$nextTick(()=>{
        this.$refs["s2s0"].init();
      })
    },
    async created(){
      this.contractAddress = this.$route.query.contract;
      this.token = this.$route.query.token;
      this.dotToken = getDotAddress(this.token)
      await requestAccount()
      setTimeout(() => {
        this.$refs["s1s0"].init();
      }, 500);
    },
    hideTopAndBottom() {
      document.getElementById("header").style.display = "none";
      document.getElementById("footer").style.display = "none";
    },
    selectMenu(index) {
      this.selectMenuIndex = index;
      this.subMenu = this.menu[index].subTitle;
      this.subSelect = 0;
      this.$nextTick(()=>{
        if(this.$refs["s" + this.selectMenuIndex + "s" + this.subSelect].init){
          this.$refs["s" + this.selectMenuIndex + "s" + this.subSelect].init();
        }
      })
    },
    parseHtml(content) {
      return content.replace("\n", "<br/>");
    },
    selectSubMenu(index) {
      this.subSelect = index;
      this.$nextTick(()=>{
        if(this.$refs["s" + this.selectMenuIndex + "s" + this.subSelect].init){
          this.$refs["s" + this.selectMenuIndex + "s" + this.subSelect].init();
        }
      })
    },

    refresh() {
      this.$refs["s" + this.selectMenuIndex + "s" + this.subSelect].init();
    },

    async getInfo() {
      if (!this.contractAddress || !this.token) {
        return;
      }
      let info = await getContractWithCache([Contract.LeadingContractFactory, Method.getLeadingContractInfoByAddress,[this.contractAddress]],0,createAndCall);

      const des=info.traderDescription;
      const desArr=des.split("$^");
      let headUrl="";
      if(desArr.length>1){
        headUrl=desArr[desArr.length-1];
      }
      if(headUrl){
        if(headUrl.startsWith("http")){
          this.userInfo.userImg=headUrl;
        }else{
          this.userInfo.userImg="https://admin.fufuture.io"+headUrl;
        }
      }
      this.userInfo.text = this.parseHtml(desArr[0] ? desArr[0] : "--")


      this.userInfo.username = info.traderName
      if(this.$refs.s0s1){
        this.$refs.s0s1.updateTrader(info.traderAddress);
      }
      let createTime=parseInt(info.createTime.toString());
      let days=Math.ceil(((new Date().getTime()/1000)-createTime)/86400);
      this.userInfo.days=days;
      let account = await getAccount()
      if (account.toLowerCase() === info.traderAddress.toLowerCase()) {
        this.showOrder = true;
        this.menu[3].show=true;
      }

      let followAllInfo = await createLeadingContractAndCall(this.contractAddress, Method.getAllFollowers)
      this.userInfo.allFollowCount = followAllInfo.length;

      let followInfo = await createLeadingContractAndCall(this.contractAddress, Method.getFollowerCount);
      this.userInfo.followCount = followInfo.toString();

      this.$refs["s0s0"].updateAddressCount(this.userInfo.followCount);

    },
    updatePan(value, total) {
      if (this.$refs["s0s0"]) {
        this.$refs["s0s0"].updatePan(value, total);
      }
      if (this.$refs["s0s1"]) {
        this.$refs["s0s1"].updatePan(value, total);
      }
    },
    showDel() {
      this.showDeleteDialog = true;
    },
    async ok1() {
      this.showDeleteDialog = false

      let price = await getLastPrice();
      let chainId = await getChainId();
      // let tigger=await getGasReward(this.token,Underling.ETH);
      let tx = await createLeadingContractAndSend(this.contractAddress, Method.traderDeleteContract, [["BTC", "ETH"], [ethers.utils.arrayify(price[Underling.BTC].hex), ethers.utils.arrayify(price[Underling.ETH].hex)]], config[chainId].verifyValue)

      console.log("tx", tx);
      if (tx) {
        this.$router.push({path: '/'})
      }
    },
    shareOpen(){
      this.$refs.share.show(this.userInfo.username,0,0,0);
    },
    goBack(){
      window.location.href="/";
    },
    async goApply(){
      let tokenInfo=await getSelectTokenInfo(this.token);
      this.$router.push({ path: '/applyFor',query:{contract:this.contractAddress,token:this.token,name:this.userInfo.username,avatar:this.userInfo.userImg,des:this.userInfo.text,tokenName:tokenInfo.symbol,rate:this.rate}})
    },
  }
}
</script>
<style scoped lang="less">
.body {

}
.hide_detail{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.header {
  padding-top: 10px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  width: 100%;
  background: black;
  z-index: 2000;
  .left {
    margin-left: 15px;
  }

  .right {
    margin-right: 15px;
  }
}

.avatar {
  display: flex;
  padding-left: 15px;
  padding-right: 15px;
  margin-top: 68px;

  .logo {
    width: 64px;
    height: 64px;
    border-radius: 50%;
  }

  .detail {
    margin-left: 10px;
    flex: 1;

    .name {
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 0px;
      line-height: 21.1px;
      color: rgba(234, 236, 239, 1);
    }

    .info {
      display: flex;
      justify-content: space-between;
      margin-top: 14px;

      .title {
        font-size: 12px;
        font-weight: 500;
        letter-spacing: -1px;
        line-height: 14.06px;
        color: rgba(128, 128, 128, 1);
      }

      .content {
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 0px;
        line-height: 14.06px;
        color: rgba(255, 255, 255, 1);
      }

      .delete {
        width: 14px;
        height: 14px;
      }
    }
  }
}

.desc {
  margin-top: 38px;
  display: flex;
  padding-left: 15px;
  padding-right: 15px;

  .detail {
    flex: 1;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 17.38px;
    color: rgba(128, 128, 128, 1);
  }

  .more {
    width: 10px;
  }
}

.menu {
  margin-top: 58px;

  .menu1 {
    border-bottom: 0.2px solid rgba(90, 90, 93, 1);
    display: flex;
    gap: 18px;
    height: 27px;
    padding-left: 15px;

    .menu-item {
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0px;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;

      &.active {
        text-decoration: underline;
        text-decoration-color: rgba(165, 214, 63, 1);
        text-underline-offset: 11px;
        text-decoration-thickness: 3px;
      }
    }

    .refresh {
      svg {
        width: 17px;
        height: 17px;
      }
    }
  }

  .menu2 {
    margin-top: 14px;
    display: flex;
    margin-left: 12px;
    gap: 8px;

    .menu-item2 {
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0px;
      line-height: 22px;
      color: rgba(128, 128, 128, 1);
      height: 22px;
      padding-left: 6px;
      padding-right: 6px;
      text-align: center;
      cursor: pointer;

      &.active {
        background: rgba(23, 23, 23, 1);
        border-radius: 4px;
        color: rgba(255, 255, 255, 1);
      }
    }
  }

}

.content {
  margin-top: 0px;
}

::v-deep .delete_dialog .el-dialog__header {
  padding: 0 !important;
  background: black;
}

::v-deep .delete_dialog .el-dialog__body {
  padding: 18px 20px !important;
}

::v-deep .el-dialog {
  background: #1E2329;
  border-radius: 10px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.25);
}

.text_box {
  color: #ffffff;
  font-weight: 400;
  font-size: 15px;
}

::v-deep .el-dialog__footer {
  display: flex !important;
  width: 100% !important;
  //padding: revert;
}
//
//.dialog_footer_box {
//  margin-top: 18px;
//
//  .data_content_button {
//    outline: none;
//    width: 150px;
//    height: 28px;
//    display: flex;
//    justify-content: center;
//    align-items: center;
//    font-size: 12px;
//  }
//}
.quick_order{
  position: fixed;
  bottom: 70px;
  width: 345px;
  height: 40px;
  border-radius: 6px;
  background: rgba(198, 254, 97, 1);
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  line-height: 40px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 2px;
  color: rgba(24, 26, 32, 1);
  text-align: center;
}
</style>
<style src="../../assets/windows.scss" lang="scss" scoped></style>
<style src="../../assets/css/mobile.scss" lang="scss" scoped></style>
<style lang="css">
.el-table, .el-table__expanded-cell {
  background: #000 !important;
}
.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
  background: #000 !important;
}
</style>